export default __webpack_public_path__ + "static/media/identity-verification-mobile.2e3520a7.svg";